var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, DynamicSvg, InfoTag, Typography, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { Pressable, View } from 'react-native';
import { BreadcrumbWidget } from '../breadcrumb-widget';
import { getPageHeaderWidgetStyles } from './PageHeaderWidgetStyles';
export var PageHeaderWidgetComponent = props => {
  var _a, _b, _c, _d, _e;
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'PageHeaderWidget' : _props$testID,
    onUserAction = props.onUserAction,
    id = props.id,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$subtitle = props.subtitle,
    subtitle = _props$subtitle === void 0 ? '' : _props$subtitle,
    _props$showLeftArrowI = props.showLeftArrowIcon,
    showLeftArrowIcon = _props$showLeftArrowI === void 0 ? true : _props$showLeftArrowI,
    _props$leftIconName = props.leftIconName,
    leftIconName = _props$leftIconName === void 0 ? 'LeftArrowIcon' : _props$leftIconName,
    _props$onLeftArrowPre = props.onLeftArrowPressMetaData,
    onLeftArrowPressMetaData = _props$onLeftArrowPre === void 0 ? {} : _props$onLeftArrowPre,
    infoTagProps = props.infoTagProps,
    _props$leftCtaProps = props.leftCtaProps,
    leftCtaProps = _props$leftCtaProps === void 0 ? {} : _props$leftCtaProps,
    _props$onLeftCtaPress = props.onLeftCtaPressMetaData,
    onLeftCtaPressMetaData = _props$onLeftCtaPress === void 0 ? {} : _props$onLeftCtaPress,
    _props$rightCtaProps = props.rightCtaProps,
    rightCtaProps = _props$rightCtaProps === void 0 ? {} : _props$rightCtaProps,
    _props$onRightCtaPres = props.onRightCtaPressMetaData,
    onRightCtaPressMetaData = _props$onRightCtaPres === void 0 ? {} : _props$onRightCtaPres,
    actionIconsProps = props.actionIconsProps,
    breadcrumbWidgetProps = props.breadcrumbWidgetProps,
    restProps = __rest(props, ["testID", "onUserAction", "id", "title", "subtitle", "showLeftArrowIcon", "leftIconName", "onLeftArrowPressMetaData", "infoTagProps", "leftCtaProps", "onLeftCtaPressMetaData", "rightCtaProps", "onRightCtaPressMetaData", "actionIconsProps", "breadcrumbWidgetProps"]);
  var pageHeaderWidgetStyles = getPageHeaderWidgetStyles(props);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: pageHeaderWidgetStyles.outerContainer
  }, restProps, {
    children: [showLeftArrowIcon && _jsx(Pressable, Object.assign({
      onPress: () => {
        onLeftArrowPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onLeftArrowPressMetaData)));
      }
    }, {
      children: _jsx(DynamicSvg, {
        iconName: leftIconName,
        fontSize: isLargeScreen ? 28 : 24,
        style: !isLargeScreen ? pageHeaderWidgetStyles.topMarginThree : {}
      })
    })), _jsxs(View, Object.assign({
      style: pageHeaderWidgetStyles.leftMarginEight
    }, {
      children: [_jsxs(View, Object.assign({
        style: pageHeaderWidgetStyles.titleInfoTagContainer
      }, {
        children: [!!title && _jsx(Typography, Object.assign({}, getTestId(testID, 'title'), {
          text: title,
          type: isLargeScreen ? 'h6' : 'body-para-xl',
          color: BLACK_900
        })), isValidObject(infoTagProps) && ((_a = infoTagProps === null || infoTagProps === void 0 ? void 0 : infoTagProps.text) === null || _a === void 0 ? void 0 : _a.length) > 0 && _jsx(View, {
          children: _jsx(InfoTag, Object.assign({}, getTestId(testID, 'info-tag'), infoTagProps, {
            size: isLargeScreen ? 'md' : 'sm',
            type: "inline",
            style: pageHeaderWidgetStyles.leftMarginEight
          }))
        })]
      })), _jsx(View, {
        children: !!subtitle && _jsx(Typography, Object.assign({}, getTestId(testID, 'subtitle'), {
          text: subtitle,
          type: isLargeScreen ? 'body-single-line-md' : 'body-para-sm',
          color: BLACK_700
        }))
      }), isValidObject(breadcrumbWidgetProps) && ((_b = breadcrumbWidgetProps === null || breadcrumbWidgetProps === void 0 ? void 0 : breadcrumbWidgetProps.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && _jsx(BreadcrumbWidget, Object.assign({}, breadcrumbWidgetProps, {
        onUserAction: onUserAction
      }))]
    })), isLargeScreen && _jsx(View, Object.assign({
      style: pageHeaderWidgetStyles.rightContainer
    }, {
      children: _jsxs(View, Object.assign({
        style: pageHeaderWidgetStyles.buttonContainer
      }, {
        children: [_jsxs(View, Object.assign({
          style: pageHeaderWidgetStyles.ctaContainer
        }, {
          children: [isValidObject(leftCtaProps) && ((_c = leftCtaProps === null || leftCtaProps === void 0 ? void 0 : leftCtaProps.title) === null || _c === void 0 ? void 0 : _c.length) > 0 && _jsx(Button, Object.assign({}, getTestId(testID, 'left-cta'), {
            size: "sm",
            buttonType: (leftCtaProps === null || leftCtaProps === void 0 ? void 0 : leftCtaProps.buttonType) || 'primary',
            title: leftCtaProps === null || leftCtaProps === void 0 ? void 0 : leftCtaProps.title
          }, leftCtaProps, {
            onPress: () => onLeftCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onLeftCtaPressMetaData)))
          })), isValidObject(rightCtaProps) && ((_d = rightCtaProps === null || rightCtaProps === void 0 ? void 0 : rightCtaProps.title) === null || _d === void 0 ? void 0 : _d.length) > 0 && _jsx(Button, Object.assign({
            style: ((_e = leftCtaProps === null || leftCtaProps === void 0 ? void 0 : leftCtaProps.title) === null || _e === void 0 ? void 0 : _e.length) > 0 ? pageHeaderWidgetStyles.leftMarginFourteen : {}
          }, getTestId(testID, 'right-cta'), {
            size: "sm",
            buttonType: (rightCtaProps === null || rightCtaProps === void 0 ? void 0 : rightCtaProps.buttonType) || 'primary',
            title: rightCtaProps === null || rightCtaProps === void 0 ? void 0 : rightCtaProps.title
          }, rightCtaProps, {
            onPress: () => onRightCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onRightCtaPressMetaData)))
          }))]
        })), _jsx(View, Object.assign({
          style: pageHeaderWidgetStyles.actionIconContainer
        }, {
          children: isValidObject(actionIconsProps) && (actionIconsProps === null || actionIconsProps === void 0 ? void 0 : actionIconsProps.length) > 0 && (actionIconsProps === null || actionIconsProps === void 0 ? void 0 : actionIconsProps.map((iconObject, index) => {
            var iconName = iconObject.iconName,
              onActionIconPress = iconObject.onActionIconPress;
            return _jsx(_Fragment, {
              children: !!iconName && _jsx(DynamicSvg, Object.assign({
                iconName: iconName,
                style: index === 0 ? {} : pageHeaderWidgetStyles.leftMarginEight,
                onPress: () => {
                  onActionIconPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                    id
                  }, onActionIconPress)));
                }
              }, getTestId(testID, 'actionable-icon-' + index)))
            });
          }))
        }))]
      }))
    }))]
  }));
};
PageHeaderWidgetComponent.genericRendererKey = 'AirPageHeaderWidget';